import { render, staticRenderFns } from "./pagination-limit.vue?vue&type=template&id=0660bfe0&"
import script from "./pagination-limit.vue?vue&type=script&lang=js&"
export * from "./pagination-limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports